import React from 'react';
import {
    IonItem,
    IonLabel,
    IonCheckbox,
    IonRange,
} from '@ionic/react';
import useStore from '../zustand/useStore';
import {actionToGetRfpAssignmentDataByFilter} from '../apiHelpers/CommonAction';
import {_getExpiryDateFromRange, _getIndianStates} from "../apiHelpers/CommonHelper";

const retainershipTypes = ['Retainership', 'Assignment'];

export default function AssignmentFilterSidebar({myPostsData}) {
    const {
        selectedRetainership,
        selectedExpiryDate,
        selectedPrice,
        selectedAssignmentLocation,

        setSelectedRetainership,
        setSelectedExpiryDate,
        setSelectedPrice,
        setSelectedAssignmentLocation,
        resetAssignmentFilters,
    } = useStore();

    const applyFilters = async (
        retainership,
        locations,
        minPrice,
        daysLeft
    ) => {
        const payload = {};
        if (retainership) payload.retainership = retainership;
        if (locations.length > 0) payload.location = locations;
        if (daysLeft) payload.expiry_date = _getExpiryDateFromRange(daysLeft);
        if (minPrice > 0) payload.price_max = minPrice;
        payload.me_mode = !!myPostsData;
        await actionToGetRfpAssignmentDataByFilter(true, payload);
    };

    const handleAssignmentTypeCheckboxChange = (value) => {
        let assignmentType;
        if (selectedRetainership === value) {
            assignmentType = ''
        } else {
            assignmentType = value;
        }
        setSelectedRetainership(assignmentType);
        applyFilters(
            assignmentType,
            selectedAssignmentLocation,
            selectedPrice,
            selectedExpiryDate
        );
    };

    const handleLocationChange = async (value) => {
        let location;
        if (selectedAssignmentLocation.includes(value)) {
            location = selectedAssignmentLocation.filter((v) => v !== value);
        } else {
            location = [...selectedAssignmentLocation, value];
        }

        setSelectedAssignmentLocation(location);
        applyFilters(
            selectedRetainership,
            location,
            selectedPrice,
            selectedExpiryDate
        );
    };

    const handlePriceChange = (e) => {
        const val = Number(e.detail.value);
        setSelectedPrice(val);
        applyFilters(
            selectedRetainership,
            selectedAssignmentLocation,
            val,
            selectedExpiryDate
        );
    };

    const handleDaysLeftChange = (value) => {
        let expiredDate;
        if (selectedExpiryDate === value) {
            expiredDate = ''
        } else {
            expiredDate = value;
        }
        setSelectedExpiryDate(expiredDate);
        applyFilters(
            selectedRetainership,
            selectedAssignmentLocation,
            selectedPrice,
            expiredDate
        );
    };

    const handleClear = async () => {
        resetAssignmentFilters();
        await actionToGetRfpAssignmentDataByFilter(true,{me_mode:!!myPostsData});
    };

    const showApplyButton =
        selectedRetainership ||
        selectedAssignmentLocation?.length > 0 ||
        selectedPrice > 0 ||
        selectedExpiryDate

    return (
        <div className="filter-sidebar-content">
            <div className="filter_main_heading_container">
                <h3 className="filter_main_heading">All Filters</h3>
                {(showApplyButton) ? (
                    <div className="filter-section-button-he clear" onClick={handleClear}>Clear</div>
                ):''}
            </div>

            {/* Assignment Type */}
            <div className="filter-section">
                <h4 className="filter_main_heading_2">Assignment Type</h4>
                {retainershipTypes.map((type) => (
                    <IonItem lines="none" key={type}>
                        <IonCheckbox
                            slot="start"
                            checked={selectedRetainership === type}
                            onIonChange={() =>
                                handleAssignmentTypeCheckboxChange(type)
                            }
                        />
                        <IonLabel>{type}</IonLabel>
                    </IonItem>
                ))}
            </div>
            <hr/>

            {/* Location */}
            <div className="filter-section">
                <h4 className="filter_main_heading_2">Location</h4>
                {_getIndianStates.map((location) => (
                    <IonItem key={location} lines="none">
                        <IonCheckbox
                            slot="start"
                            checked={selectedAssignmentLocation.includes(location)}
                            onIonChange={() => handleLocationChange(location)}
                        />
                        <IonLabel>{location}</IonLabel>
                    </IonItem>
                ))}
            </div>
            <hr/>

            {/* Minimum Price Offered */}
            <div className="filter-section">
                <h4 className="filter_main_heading_2">Maximum Price Offered (₹)</h4>
                <IonRange min={10000} max={100000} step={5000} pin snaps value={selectedPrice}
                          onIonChange={handlePriceChange}/>
                <div className="range-labels">
                    <span>₹10,000</span>
                    <span>₹1,00,000</span>
                </div>
            </div>
            <hr/>

            {/* Days Left */}
            <div className="filter-section">
                <h4 className="filter_main_heading_2">Days Left</h4>
                {['1-7', '8-15', '16+'].map((range) => (
                    <IonItem lines="none" key={range}>
                        <IonCheckbox
                            slot="start"
                            checked={selectedExpiryDate === range}
                            onIonChange={() => handleDaysLeftChange(range)}
                        />
                        <IonLabel>{range} Days</IonLabel>
                    </IonItem>
                ))}
            </div>
            <hr/>
        </div>
    );
}
